export const OHL = {
    name: 'DV 1228A RP ĐERDAP 2 - HE ĐERDAP 2, blok 1',
    voltage: '110',
    regionCode: 'BR',
    stanice: [{name: 'ĐERDAP 2', position: {lat: 44.2983, lng: 22.565}}],
    position: 'N',
    stubovi: [
        { index: 1, name: 'P1', lat: 44.2983 , lng: 22.5647, sys: 1, portal: true },
        { index: 2, name: '5', lat: 44.2988 , lng: 22.5649, sys: 2},
        { index: 3, name: '4', lat: 44.3013 , lng: 22.5656, sys: 2},
        { index: 4, name: '3', lat: 44.3043 , lng: 22.5665, sys: 2},
        { index: 5, name: '2', lat: 44.3057 , lng: 22.567, sys: 2},
        { index: 6, name: '1', lat: 44.3063 , lng: 22.5665, sys: 2},
        { index: 7, name: 'P.B. - 1', lat: 44.3062 , lng: 22.5665, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P1 - 5', position: [{ lat: 44.2983 , lng: 22.5647 }, { lat: 44.2988 , lng: 22.5649 }] },
        { name: '5 - 4', position: [{ lat: 44.2988 , lng: 22.5649 }, { lat: 44.3013 , lng: 22.5656 }] },
        { name: '4 - 3', position: [{ lat: 44.3013 , lng: 22.5656 }, { lat: 44.3043 , lng: 22.5665 }] },
        { name: '3 - 2', position: [{ lat: 44.3043 , lng: 22.5665 }, { lat: 44.3057 , lng: 22.567 }] },
        { name: '2 - 1', position: [{ lat: 44.3057 , lng: 22.567 }, { lat: 44.3063 , lng: 22.5665 }] },
        { name: '1 - P.B. - 1', position: [{ lat: 44.3063 , lng: 22.5665 }, { lat: 44.3062 , lng: 22.5665 }] }
    ]
}
